module.exports = __webpack_public_path__ + "img/dianxin.c2488ecb.png";